// extracted by mini-css-extract-plugin
export default {"cursorOuter":"CustomCursor_cursorOuter__8lS1v","cursorInner":"CustomCursor_cursorInner__fWz4G"};